import { inject } from "mobx-react";
import FlyoutPanel from "components/flyoutPanel/FlyoutPanel";
import { getQuickToolsVerbs, getFilteredVerbGroups } from "selectors/quickToolsSelectors";

const mapStateToProps = (store, ownProps) => ({
  ...ownProps,
  quickToolsVerbs: getQuickToolsVerbs(store),
  filteredVerbGroups: getFilteredVerbGroups(store)
});

const FlyoutPanelContainer = inject(mapStateToProps)(FlyoutPanel);
export default FlyoutPanelContainer;
